import type { InferRpcDefinition } from "@redotech/rpc/definition";
import { adjustInventory } from "./schema/adjust-inventory";
import { cancelAdjustmentSession } from "./schema/adjustment-session/cancel-adjustment-session";
import { createAdjustmentSession } from "./schema/adjustment-session/create-adjustment-session";
import { getAdjustmentSession } from "./schema/adjustment-session/get-adjustment-session";
import { listAdjustmentSessions } from "./schema/adjustment-session/list-adjustment-sessions";
import { submitAdjustmentSession } from "./schema/adjustment-session/submit-adjustment-session";
import { updateAdjustmentSession } from "./schema/adjustment-session/update-adjustment-session";
import { createInventoryTransfer } from "./schema/create-inventory-transfer";
import { createMarketplaceListing } from "./schema/create-marketplace-listing";
import { deleteProduct } from "./schema/delete-product";
import { getForecastingProducts } from "./schema/forecasting/get-forecasting-products";
import { getProductVendors } from "./schema/forecasting/get-product-vendors";
import { getCatalogProducts } from "./schema/get-catalog-products";
import { getCatalogUniqueValues } from "./schema/get-catalog-unique-values";
import { getInventoryTransfers } from "./schema/get-inventory-transfers";
import { getLocations } from "./schema/get-locations";
import { getMarketplaceListings } from "./schema/get-marketplace-listings";
import { getMerchantInventory } from "./schema/get-merchant-inventory";
import { getProductById } from "./schema/get-product-by-id";
import { getProductDetails } from "./schema/get-product-details";
import { getProductFamilies } from "./schema/get-product-families";
import { getProductFamilyDetails } from "./schema/get-product-family-details";
import { getProductInventory } from "./schema/get-product-inventory";
import { getProducts } from "./schema/get-product2-products";
import { getProductsForInventory } from "./schema/get-products-for-inventory";
import { getRedoProduct } from "./schema/get-redo-product";
import { getSkuSalesForecast } from "./schema/get-sku-sales-forecast";
import { getSuggestedProductsForLiquidation } from "./schema/get-suggested-products-for-liquidation";
import { getVariantInventoryByLocation } from "./schema/get-variant-inventory-by-location";
import { getWarehouses } from "./schema/get-warehouses";
import { getWarehousesForTeam } from "./schema/get-warehouses-for-team";
import { integrateInventory } from "./schema/integrate-inventory";
import { listConsignedProducts } from "./schema/list-consigned-products";
import { listProducts } from "./schema/list-products";
import { createPricingRule } from "./schema/pricing-rules/create-pricing-rule";
import { deletePricingRule } from "./schema/pricing-rules/delete-pricing-rule";
import { getPricingRules } from "./schema/pricing-rules/get-pricing-rules";
import { updatePricingRule } from "./schema/pricing-rules/update-pricing-rule";
import { createPurchaseOrder } from "./schema/purchase-orders/create-purchase-order";
import { getPurchaseOrder } from "./schema/purchase-orders/get-purchase-order";
import { getPurchaseOrders } from "./schema/purchase-orders/get-purchase-orders";
import { updatePurchaseOrder } from "./schema/purchase-orders/update-purchase-order";
import { searchProducts } from "./schema/search-products";
import { createSupplier } from "./schema/suppliers/create-supplier";
import { getSupplier } from "./schema/suppliers/get-supplier";
import { getSuppliers } from "./schema/suppliers/get-suppliers";
import { updateSupplier } from "./schema/suppliers/update-supplier";
import { updateInventoryTransfer } from "./schema/update-inventory-transfer";
import { updateMarketplaceListing } from "./schema/update-marketplace-listing";
import { upsertInventoryItem } from "./schema/upsert-inventory-item";

export const rpcDefinition = {
  adjustInventory,
  cancelAdjustmentSession,
  createAdjustmentSession,
  createInventoryTransfer,
  createMarketplaceListing,
  createPricingRule,
  createPurchaseOrder,
  createSupplier,
  deletePricingRule,
  deleteProduct,
  getAdjustmentSession,
  getCatalogProducts,
  getForecastingProducts,
  getProductVendors,
  getCatalogUniqueValues,
  getInventoryTransfers,
  getLocations,
  getMarketplaceListings,
  getMerchantInventory,
  getPricingRules,
  getProductById,
  getProductDetails,
  getProductFamilies,
  getProductFamilyDetails,
  getProductInventory,
  getProducts,
  getProductsForInventory,
  getPurchaseOrder,
  getPurchaseOrders,
  getRedoProduct,
  getSkuSalesForecast,
  getSuggestedProductsForLiquidation,
  getSupplier,
  getSuppliers,
  getVariantInventoryByLocation,
  getWarehouses,
  getWarehousesForTeam,
  integrateInventory,
  listAdjustmentSessions,
  listConsignedProducts,
  listProducts,
  searchProducts,
  submitAdjustmentSession,
  updateAdjustmentSession,
  updateInventoryTransfer,
  updateMarketplaceListing,
  updatePricingRule,
  updatePurchaseOrder,
  updateSupplier,
  upsertInventoryItem,
};

export type RedoInventoryRpcDefinition = InferRpcDefinition<
  typeof rpcDefinition
>;
